import React from 'react';
import './BookATable.css';

function BookATable() {
  return (
    <div className="book-a-table-container">
      <p className="tagline">Craving something special? Book your spot now!</p>
    </div>
  );
}

export default BookATable;